module.exports = __webpack_public_path__ + "static/media/style-icon.48cd7678.svg";